import { admin2 } from './instance'

// GET admin.salesPos.getMemberDetail
export const GetSalesPosMemberDetail = async ({ shopId, memberId, date }) => {
  return await admin2({
    url: `/${shopId}/salesPos/getMemberDetail`,
    method: 'GET',
    params: {
      memberId,
      date,
    },
  })
}

// GET admin.salesPos.searchMember
export const GetSalesPosSearchMember = async ({ shopId, search, memberId }) => {
  return await admin2({
    url: `/${shopId}/salesPos/searchMember`,
    method: 'GET',
    params: { search, memberId },
  })
}

// GET admin.salesPos.creationConfig
export const GetSalesPosCreationConfig = async ({ shopId }) => {
  return await admin2({
    url: `/${shopId}/salesPos/creationConfig`,
    method: 'GET',
  })
}
// GET admin.salesPos.creationConfigV2
export const GetSalesPosCreationConfigV2 = async ({ shopId }) => {
  return await admin2({
    url: `/${shopId}/salesPos/creationConfigV2`,
    method: 'GET',
  })
}

// GET admin.salesPos.qrCodeCheckMember
export const GetSalesPosQrCodeCheckMember = async ({ shopId, memberId }) => {
  return await admin2({
    url: `/${shopId}/salesPos/qrCodeCheckMember`,
    method: 'GET',
    params: { memberId },
  })
}

// GET admin.salesPos.getTodayMemberAppointmentOrders
export const GetSalesPosTodayMemberAppointmentOrders = async ({ shopId, memberId }) => {
  return await admin2({
    url: `/${shopId}/salesPos/getTodayMemberAppointmentOrders`,
    method: 'GET',
    params: { memberId },
  })
}

// POST admin.salesPos.preCreateReward
export const SalesPosPreCreateReward = async ({
  shopId, memberId, salesRecordItems,
  salesRecordDiscounts,
  setSalesCashbackAmount,
}) => {
  return await admin2({
    url: `/${shopId}/salesPos/preCreateReward`,
    method: 'POST',
    data: {
      memberId,
      salesRecordItems,
      salesRecordDiscounts,
      setSalesCashbackAmount,
    },
  })
}

/**
 * 建立銷售記錄 admin.salesPos.createSalesRecord
 * @param {Object} params - 建立銷售記錄參數
 * @param {string} params.shopId - 商店ID
 * @param {Object} params.customer - 客戶資訊
 * @param {Array<Object>} params.salesRecordItems - 銷售項目列表
 * @param {Array<Object>} [params.salesRecordItems[].itemDiscounts] - 單項折扣列表
 * @param {string} [params.salesRecordItems[].itemDiscounts[].type] - 折扣類型 ('discount' | 'noSource')
 * @param {Object} [params.salesRecordItems[].itemDiscounts[].spendRecord] - 點數折抵資訊
 * @param {string} [params.salesRecordItems[].itemDiscounts[].spendRecord.type] - 折抵類型 ('point')
 * @param {number} [params.salesRecordItems[].itemDiscounts[].spendRecord.amount] - 使用的點數數量
 * @param {string} [params.salesRecordItems[].itemDiscounts[].spendRecord.shopPointKey] - 點數類型 key（必填，識別使用哪個點數錢包）
 * @param {string} [params.salesRecordItems[].itemDiscounts[].name] - 折扣名稱
 * @param {number} [params.salesRecordItems[].itemDiscounts[].savePrice] - 優惠金額（根據 amount × pointDiscountRate 計算）
 * @param {number} [params.salesRecordItems[].itemDiscounts[].order] - 折扣順序
 * @param {Array<Object>} params.salesRecordDiscounts - 整單折扣列表
 * @param {string} params.salesRecordDiscounts[].type - 折扣類型 ('discount' | 'noSource' | 'salesActivityDiscount')
 * @param {Object} [params.salesRecordDiscounts[].spendRecord] - 點數折抵資訊（若使用點數整單折抵）
 * @param {string} [params.salesRecordDiscounts[].spendRecord.type] - 折抵類型 ('point')
 * @param {number} [params.salesRecordDiscounts[].spendRecord.amount] - 使用的點數數量
 * @param {string} [params.salesRecordDiscounts[].spendRecord.shopPointKey] - 點數類型 key（必填，識別使用哪個點數錢包）
 * @param {string} params.salesRecordDiscounts[].name - 折扣名稱
 * @param {number} params.salesRecordDiscounts[].savePrice - 優惠金額
 * @param {string|null} [params.salesRecordDiscounts[].salesActivityDiscountId] - 銷售活動 ID（當 type='salesActivityDiscount' 時）
 * @param {number} params.salesRecordDiscounts[].order - 折扣順序
 * @param {Array<Object>} params.salesRecordPayments - 付款方式列表
 * @param {Object} params.confirmInfo - 確認資訊
 * @param {Object} params.settings - 設定
 * @returns {Promise<Object>} 建立的銷售記錄
 */
export const SalesPosCreateSalesRecord = async ({
  shopId,
  customer,
  salesRecordItems,
  salesRecordDiscounts,
  salesRecordPayments,
  confirmInfo,
  settings,
  invoice,
}) => {
  return await admin2({
    url: `/${shopId}/salesPos/createSalesRecord`,
    method: 'POST',
    data: {
      customer,
      salesRecordItems,
      salesRecordDiscounts,
      salesRecordPayments,
      confirmInfo,
      settings,
      originDevice: 'dashboard',
      invoice,
    },
  })
}
